import styled from 'styled-components';
import { color } from 'styles/pallete';

interface ContainerProps {
	$pBottom: number;
	$pTop: number;
}

export const container = styled.div<ContainerProps>`
	position: relative;
	width: 100%;
	height: 200px;
	display: flex;
	gap: 1rem;
	align-items: center;
	justify-content: center;
	padding-top: ${(props) => props.$pTop}px;
	padding-bottom: ${(props) => props.$pBottom}px;

	> svg {
		font-size: 2rem;
		color: ${color.interface.lightGray};
	}

	> p {
		font-size: 1.3rem;
		opacity: 0.8;
		color: ${color.interface.lightGray};
	}
`;

export const videoEmbed = styled.div`
	z-index: 1;
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	> iframe {
		all: unset;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;

export const load = styled.div`
	position: absolute;
`;

export const clicks = styled.div`
	position: absolute;
	bottom: 0px;
	right: 0px;
	border-bottom-right-radius: 5px;
	border-top-left-radius: 5px;
	background-color: ${color.interface.darkgray2};
	padding: 1px 5px;
	opacity: 0.8;
	font-weight: 900;
	font-size: 1.3rem;

	> p {
		font-size: 1rem;
		color: ${color.interface.white};
	}
`;

export const noData = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	gap: 1.5rem;
	background-color: ${color.interface.white};

	> p {
		width: 80%;
		text-align: center;
		font-size: 1.3rem;
		color: ${color.interface.lightGray};
	}
`;

export const notice = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	padding: 4rem;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	z-index: 2;
	gap: 1.5rem;
	background-color: ${color.interface.white};

	> p {
		width: 80%;
		text-align: center;
		font-size: 1.3rem;
		color: ${color.interface.lightGray};
	}
`;
